// eslint-disable-next-line import/prefer-default-export
export const AUTH_RESENT_MODAL_ID = 'AUTH_RESENT_MODAL_ID'

export const ALERT_MODAL_ID = 'ALERT_MODAL_ID'
